import api from './api';

export default {
    createSession() {
        return api.get(`${process.env.VUE_APP_URL_PRO}/sanctum/csrf-cookie`);
    },

    login(params){
        return api.post(`${process.env.VUE_APP_URL}/login` , params);
    },

    changePassowrd(params){
        return api.post(`${process.env.VUE_APP_URL}/change-password` , params);
    },

    updateDataAdmin(params){
        return api.post(`${process.env.VUE_APP_URL}/organizations/update/admin` , params);
    },

    forgetPassword(params){
        return api.post(`${process.env.VUE_APP_URL}/forget-password` , params);
    },

    resetPassword(params){
        return api.post(`${process.env.VUE_APP_URL}/reset-password` , params);
    },

    logout(){
        return api.post(`${process.env.VUE_APP_URL}/logout`);
    },
    saveUser(params){
        return api.post(`${process.env.VUE_APP_URL}/users`, params);
    },
    saveUserAnswers(params){
        return api.post(`${process.env.VUE_APP_URL}/user/answers`, params);
    },
    restoreUserAnswer(competitionId,userId){
        return api.get(`${process.env.VUE_APP_URL}/restore/user/answers/${competitionId}/${userId}`);
    },
    getUserTeamLeaderOrMemeber(competitionId,id){
        return api.get(`${process.env.VUE_APP_URL}/get/user/teamLeaderOrMember/${competitionId}/${id}`);
    },
    retoreTeamMember(competitionId,entityId,userId){
        return api.get(`${process.env.VUE_APP_URL}/restore/team/member/${competitionId}/${entityId}/${userId}`);
    },
    getSubUsers(params){
        return api.get(`${process.env.VUE_APP_URL}/users/${params}`);
    },
    getRoles(){
        return api.get(`${process.env.VUE_APP_URL}/user/roles`);
    },
    index(model, search=false, sort='asc' , paginate=true, page=1 , userCountFlag = false){
        return api.get(`${process.env.VUE_APP_URL}/${model}` , {params: {search:search , sort:sort , paginate:paginate,page:page,userCountFlag: userCountFlag}});
    },
    create(model, params){
        return api.post(`${process.env.VUE_APP_URL}/${model}` , params);
    },

    uploadMaterial(params){
        return api.post(`${process.env.VUE_APP_URL}/template/upload/materials` , params);
    },
    uploadAttachments(params){
        return api.post(`${process.env.VUE_APP_URL}/template/upload/attachments` , params);
    },

    getTemplates(sort='asc' , paginate= false, page=1, attachment= true){
        return api.get(`${process.env.VUE_APP_URL}/templates` , {params: {sort:sort , paginate:paginate,page:page, attachment:attachment}});
    },
    show(model, id){
        return api.get(`${process.env.VUE_APP_URL}/${model}/${id}`);
    },
    view(model, id){
        return api.get(`${process.env.VUE_APP_URL}/${model}/${id}/view`);
    },
    update(model, id , params){
        return api.put(`${process.env.VUE_APP_URL}/${model}/${id}` , params);
    },
    delete(model, id){
        return api.delete(`${process.env.VUE_APP_URL}/${model}/${id}`);
    },
    getMaterial(orgName, templateName, fileName){
        return api.get(`${process.env.VUE_APP_AWS_STREEM_URL}/materials/${orgName}/${templateName}/${fileName}`);
    },

    getAttachmentStatus(templateId){
        return api.get(`${process.env.VUE_APP_URL}/templates/${templateId}/get-attachments-status`);
    },
    getOrganization(){
        return api.get(`${process.env.VUE_APP_URL}/getOrganization`);
    },
    getTemplateData(id , params){
        return api.post(`${process.env.VUE_APP_URL}/template/get/data/${id}` , params);
    },
    getAvailableStorage(){
        return api.get(`${process.env.VUE_APP_URL}/get-storage`);
    }
}